<template>
  <v-autocomplete
    dense
    color="cyan"
    filled
    :id="id"
    :items="timeList"
    v-model="time"
    :placeholder="placeholder"
    solo
    flat
    item-color="cyan"
    hide-details
    v-on:change="emitValue()"
    :disabled="disabled"
  />
</template>

<script>
import moment from "moment-timezone";
moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "timepicker",
  model: {
    prop: "value",
    event: "input",
  },
  props: {
    id: {
      type: String,
      default: "start-time",
    },
    intervel: {
      type: Number,
      default: 60,
    },
    placeholder: {
      type: String,
      default: "Start Time",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: null,
    },
    minTime: {
      type: String,
      default: null,
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
  },
  watch: {
    value: function () {
      this.init();
    },
    minTime: function () {
      /*  this.time = null; */
      this.emitValue();
      this.initTimeList();
    },
    startDate: function () {
      this.initTimeList();
    },
    endDate: function () {
      this.initTimeList();
    },
  },
  data() {
    return {
      time: null,
      timeList: [],
    };
  },
  methods: {
    init() {
      this.time = this.value;
    },
    emitValue() {
      this.$emit("input", this.time);
      this.$emit("change", this.time);
    },
    isDifferentDay() {
      if (this.startDate && this.endDate) {
        const startD = moment(this.startDate);
        const endD = moment(this.endDate);
        if (startD.isValid() && endD.isValid() && !endD.isSame(startD, "day")) {
          return true;
        }
      }
      return false;
    },
    initTimeList() {
      this.timeList = [];
      let startTime = moment().startOf("day");
      let endTime = moment().endOf("day");
      let minTime =
        this.minTime && !this.isDifferentDay()
          ? moment(`${moment().format("YYYY-MM-DD")} ${this.minTime}`)
          : null;
      let value = startTime.format("hh:mm A");
      while (startTime.isBefore(endTime)) {
        if (minTime && startTime.isBefore(minTime)) {
          this.timeList.push({ text: value, value, disabled: true });
        } else {
          this.timeList.push({ text: value, value, disabled: false });
        }
        value = startTime.add(this.intervel, "minutes").format("hh:mm A");
      }
    },
    /* initTimeList() {
      this.timeList = [];
      let startTime = moment().startOf("day");
      let endTime = moment().endOf("day");
      let minTime = this.minTime
        ? moment(`${moment().format("YYYY-MM-DD")} ${this.minTime}`)
        : null;
      while (startTime.isBefore(endTime)) {

        let value = startTime.add(30, "minutes").format("hh:mm A");
        if (startTime && startTime.isBefore(minTime)) {
          this.timeList.push({ text: value, value, disabled: true });
        } else {
          this.timeList.push({ text: value, value, disabled: false });
        }
      }
    }, */
  },
  mounted() {
    this.init();
    this.initTimeList();
  },
};
</script>
